import { SchemaFormFields } from '@mews-commander/form';
import { Stack } from '@optimus-web/core';
import { FormPercentageInputField, lt } from '@mews/framework';
import { percentagePriceAdjustmentUpsertSchema } from '../schemas';

interface PercentageValueFieldProps {
    name: string;
}

export const PercentageValueField = ({ name }: PercentageValueFieldProps) => (
    <SchemaFormFields
        namePrefix={name}
        schema={percentagePriceAdjustmentUpsertSchema}
        formDefinition={{
            fields: {
                multiplier: {
                    label: lt('GeneralAdjustedPriceTaxExcl'),
                    required: true,
                    render: (props) => <FormPercentageInputField {...props} />,
                },
                amountPart: {
                    label: lt('ConfigureProductServicesFieldApplyTo'),
                    field: {
                        type: 'enum',
                        enumPrefix: 'AmountPart',
                        omitHint: true,
                    },
                    required: true,
                },
            },
            renderFields: (fields) => (
                <Stack spacing="50" distribution="stretch">
                    {fields.multiplier}
                    {fields.amountPart}
                </Stack>
            ),
        }}
    />
);
